import type { IUser} from "~~/types/user";
import { PermissionType, EAccountType } from "~~/types/user";
import { posthog } from "posthog-js";

export const getAllowedRoutes = (permissions?: IUser["permissions"], user?: IUser) => {
  // reference: https://us.posthog.com/project/193072/feature_flags/161574
  const globalEnabledRoutes = posthog.getFeatureFlagPayload("global-enabled-routes") || {
    [PermissionType.DASHBOARD_READ]: true,
    [PermissionType.CASE_READ_SELF]: true,
    [PermissionType.CASE_READ_OTHER]: true,
    [PermissionType.REQUEST_READ]: true,
    [PermissionType.USER_READ]: true,
    [PermissionType.PROFILE_READ]: true,
    [PermissionType.REPORT_READ]: true,
    [PermissionType.TRACK_SELF]: true,
    [PermissionType.TRACK_OTHER]: true,
    [PermissionType.COMPANY_READ]: true,
    [PermissionType.NEWS_CREATE]: true,
    [PermissionType.NEWS_UPDATE]: true,
    [PermissionType.NEWS_DELETE]: true,
    [PermissionType.POLICY_READ]: true,
    [PermissionType.SETTINGS_READ]: true,
  }

  const routes = !permissions
    ? {
      dashboard: false,
      case: false,
      "case-request": false,
      user: false,
      profile: false,
      report: false,
      track: false,
      company: false,
      news: false,
      policy: false,
      trace: false,
      settings: false,
      login: true,
    }
    : {
      dashboard:
        globalEnabledRoutes?.[PermissionType.DASHBOARD_READ] && permissions.includes(PermissionType.DASHBOARD_READ),
      case:
        globalEnabledRoutes?.[PermissionType.CASE_READ_SELF] &&
        (permissions.includes(PermissionType.CASE_READ_SELF) || permissions.includes(PermissionType.CASE_READ_OTHER)),
      "case-request":
        globalEnabledRoutes?.[PermissionType.REQUEST_READ] && permissions.includes(PermissionType.REQUEST_READ),
      user: globalEnabledRoutes?.[PermissionType.USER_READ] && permissions.includes(PermissionType.USER_READ),
      profile:
        globalEnabledRoutes?.[PermissionType.PROFILE_READ] && permissions.includes(PermissionType.PROFILE_READ),
      report: globalEnabledRoutes?.[PermissionType.REPORT_READ] && permissions.includes(PermissionType.REPORT_READ),
      track:
        globalEnabledRoutes?.[PermissionType.TRACK_SELF] &&
        (permissions.includes(PermissionType.TRACK_SELF) || permissions.includes(PermissionType.TRACK_OTHER)),
      company:
        globalEnabledRoutes?.[PermissionType.COMPANY_READ] && permissions.includes(PermissionType.COMPANY_READ),
      news:
        globalEnabledRoutes?.[PermissionType.NEWS_CREATE] &&
        (permissions.includes(PermissionType.NEWS_CREATE) ||
          permissions.includes(PermissionType.NEWS_UPDATE) ||
          permissions.includes(PermissionType.NEWS_DELETE)),
      login: true,
      policy: globalEnabledRoutes?.[PermissionType.POLICY_READ] || permissions.includes(PermissionType.POLICY_READ),
      trace: user?.accountType === EAccountType.ADMIN || user?.accountType === EAccountType.OWNER,
      settings: permissions.includes(PermissionType.SETTINGS_READ),
    };

  return Object.keys(routes).reduce((acc, key) => {
    if (routes[key]) {
      acc.push(key);
    }

    return acc;
  }, [] as Array<string>);
};
